module.exports = __webpack_public_path__ + "img/SES_191288802.71dd5c77.jpg";